import { useEffect, useMemo, useState } from "react";
import cbn from "../../assets/icons/cbn.svg";
import BvnValidationDialog from "../../Components/BvnValidationDialog";
import Otp from "../../Components/OtpDialog";
import UpdateDetailSwiftSavingsDialog from "../../Components/UpdateDetailsDialog/UpdateDetailSwiftSavingsDialog";
import AccountOpeningSuccessDialog from "../../Components/AccountOpeningSuccessDialog";
import { useSelector } from "react-redux";
import UpdateDetailSavingsDialog from "../../Components/UpdateDetailsDialog/UpdateDetailSavingsDialog";
import UpdateDetailMinorSavingsDialog from "../../Components/UpdateDetailsDialog/UpdateDetailMinorSavingsDialog";
import UpdateDetailJointSavingsDialog from "../../Components/UpdateDetailsDialog/UpdateDetailJointSavingsDialog";
import UpdateDetailCurrentDialog from "../../Components/UpdateDetailsDialog/UpdateDetailCurrentDialog";
import UpdateDetailJointCurrentDialog from "../../Components/UpdateDetailsDialog/UpdateDetailJointCurrentDialog";
import UpdateDetailDomiciliaryCurrentDialog from "../../Components/UpdateDetailsDialog/UpdateDetailDomiciliaryCurrentDialog";
import UpdateDetailDomiciliarySavingsDialog from "../../Components/UpdateDetailsDialog/UpdateDetailDomiciliarySavingsDialog";
import UploadDocumentSwiftSavingsDialog from "../../Components/UploadDocumentDialog/UploadDocumentSwiftSavingsDialog";
import UploadDocumentSavingsDialog from "../../Components/UploadDocumentDialog/UploadDocumentSavingsDialog";
import UploadDocumentMinorSavingsDialog from "../../Components/UploadDocumentDialog/UploadDocumentMinorSavingsDialog";
import UploadDocumentJointSavingsDialog from "../../Components/UploadDocumentDialog/UploadDocumentJointSavingsDialog";
import UploadDocumentDomiciliarySavingsDialog from "../../Components/UploadDocumentDialog/UploadDocumentDomiciliarySavingsDialog";
import UploadDocumentCurrentDialog from "../../Components/UploadDocumentDialog/UploadDocumentCurrentDialog";
import UploadDocumentJointCurrentDialog from "../../Components/UploadDocumentDialog/UploadDocumentJointCurrentDialog";

import UploadDocumentDomiciliaryCurrentDialog from "../../Components/UploadDocumentDialog/UploadDocumentDomiciliaryCurrentDialog";
import ExUpdateDetailsSavingsDialog from "../../Components/ExistingAccount/exUpdateDetailsDialog/ExUpdateDetailsSavingsDialog";
import ExBvnValidationDialog from "../../Components/ExistingAccount/ExBvnValidationDialog";
import AddReferenceCurrentDialog from "../../Components/AddReference/AddReferenceCurrentDialog";

import ExUploadDocumentSavingsDialog from "../../Components/ExistingAccount/exUploadDocumentsDialog/ExUploadDocumentSavingsDialog";
import ExUploadDocumentsMinorSavings from "../../Components/ExistingAccount/exUploadDocumentsDialog/ExUploadDocumentsMinorSavings";
import ExUploadDocumentsJointSavingsDialog from "../../Components/ExistingAccount/exUploadDocumentsDialog/ExUploadDocumentsJointSavingsDialog";
import ExUploadDocumentsDomiciliarySavingsDialog from "../../Components/ExistingAccount/exUploadDocumentsDialog/ExUploadDocumentsDomiciliarySavingsDialog";
import ExUploadDocumentsCurrentDialog from "../../Components/ExistingAccount/exUploadDocumentsDialog/ExUploadDocumentsCurrentDialog";

import style from "./style.module.css";
import ExUploadDocumentDomiciliaryCurrentDialog from "../../Components/ExistingAccount/exUploadDocumentsDialog/ExUploadDocumentDomiciliaryCurrent";
import {
  accountOpeningSteps,
  accountSteps,
  accountTypes,
  glCodes,
} from "../../utils/constants";
import ExUploadDocumentJointCurrentDialog from "../../Components/ExistingAccount/exUploadDocumentsDialog/ExUploadDocumentJointCurrentDialog";
import ExUploadDocumentsSwiftSavingsDialog from "../../Components/ExistingAccount/exUploadDocumentsDialog/ExUploadDocumentsSwiftSavings";
import AltBankLogo from "../../Components/AltbankLogo";
import Stepper from "../../Components/Stepper";
import UpdateGuardianDetails from "../../Components/UpdateDetailsDialog/UpdateGuardianDetails";
import AddRefefAcurrent from "../../Components/AddReffAcurrent/";
import AddRefDomcurrent from "../../Components/AddReffADomcurrent";
import SuccessDialog from "../../Components/AccountOpeningSuccessDialog/SuccessDialog";
import { useSearchParams } from "react-router-dom";
import apiHooks from "../../customHooks/apis";

function OpenAccount(props: any) {
  const { useGetSavingsAccountTypes } = apiHooks;
  const { savingsAccountTypes } = useGetSavingsAccountTypes();
  const [URLSearchParams] = useSearchParams();
  // const { accountOpeningStep } = {
  //   accountOpeningStep: accountOpeningSteps.documentUpload,
  // };
  const { accountOpeningStep } = useSelector(
    (state: any) => state.accountOpeningData,
  );
  const [accountType, setAccountType] = useState<string>("");
  const [accountStatus, setAccountStatus] = useState<string>("");
  const searchParam = URLSearchParams.get("accountType");

  const currentSteps = useMemo(
    () =>
      accountSteps[
        accountType?.includes("Minor")
          ? "minor"
          : accountType?.includes("Swift")
            ? "swift"
            : accountType?.includes("Current")
              ? "current"
              : "others"
      ],
    [accountSteps, accountType],
  );

  const currentStepIndex = useMemo(
    () =>
      accountOpeningStep === accountOpeningSteps?.accountOpeningSuccess
        ? currentSteps?.length
        : currentSteps?.findIndex((step) =>
            step?.toLowerCase()?.includes(accountOpeningStep?.split("-")[0]),
          ),
    [currentSteps, accountOpeningStep],
  );
  useEffect(() => {
    const acctTypeFromStorage = localStorage.getItem("altFinanceAccountType");
    const acctStatusFromStorage = localStorage.getItem("accountStatus");
    acctTypeFromStorage && setAccountType(acctTypeFromStorage);
    acctStatusFromStorage && setAccountStatus(acctStatusFromStorage);
  }, []);

  useEffect(() => {
    if (searchParam && searchParam.toLowerCase() === "swiftsavings") {
      localStorage.setItem("altFinanceAccountType", "Swift Savings");
      localStorage.setItem("accountStatus", "new");
      localStorage.setItem(
        "altFinanceGlCode",
        savingsAccountTypes.find(
          (item) => item.account_Type === "Swift Savings",
        )?.glCode,
      );
      setAccountType("Swift Savings");
      setAccountStatus("new");
    }
  }, [searchParam, savingsAccountTypes]);

  return (
    <div>
      <div className="container-fluid row">
        <div
          className="col-md-5 d-none d-md-inline left_col"
          style={{ minHeight: "100vh", position: "relative" }}
        >
          <div className="logo pl-4 pt-4">
            <AltBankLogo colored />
          </div>
          <div className={style.footer}>
            <p>
              Licensed by Central Bank of Nigeria{" "}
              <img src={cbn} alt="cbn-icon" /> | Powered by{" "}
              <span>The Alternative Bank</span>
            </p>
          </div>
        </div>

        <div className="col-md-7 right_col">
          <div className="row">
            <Stepper
              label={accountType}
              steps={currentSteps}
              currentStepIndex={currentStepIndex > -1 ? currentStepIndex : 0}
            />
          </div>

          <div className="row">
            <div className="col-md-11 card validation-card pb-4 d-non">
              {(accountOpeningStep === "bvn-validation" ||
                accountOpeningStep === accountOpeningSteps.accountValidation) &&
              accountStatus === "new" ? (
                <BvnValidationDialog />
              ) : (
                ""
              )}

              {accountOpeningStep === "otp" ? <Otp /> : ""}

              {accountOpeningStep === accountOpeningSteps.updateDetail &&
              accountStatus === "new" &&
              accountType?.toLowerCase() === accountTypes?.swiftSavings ? (
                <UpdateDetailSwiftSavingsDialog />
              ) : (
                ""
              )}
              {accountOpeningStep === accountOpeningSteps.updateDetail &&
              accountStatus === "new" &&
              accountType?.toLowerCase() === accountTypes?.regularSavings ? (
                <UpdateDetailSavingsDialog />
              ) : (
                ""
              )}
              {accountOpeningStep === accountOpeningSteps.minorDetails &&
              accountStatus === "new" &&
              accountType?.toLowerCase() === accountTypes?.minorSavings ? (
                <UpdateDetailMinorSavingsDialog />
              ) : (
                ""
              )}
              {accountOpeningStep === accountOpeningSteps.guardianDetails &&
              accountStatus === "new" &&
              accountType?.toLowerCase() === accountTypes?.minorSavings ? (
                <UpdateGuardianDetails />
              ) : (
                ""
              )}
              {accountOpeningStep === accountOpeningSteps.updateDetail &&
              accountStatus === "new" &&
              accountType?.toLowerCase() === accountTypes?.jointSavings ? (
                <UpdateDetailJointSavingsDialog />
              ) : (
                ""
              )}

              {accountOpeningStep === accountOpeningSteps.updateDetail &&
              accountStatus === "new" &&
              accountType?.toLowerCase() ===
                accountTypes?.domiciliarySavings ? (
                <UpdateDetailDomiciliarySavingsDialog />
              ) : (
                ""
              )}
              {accountOpeningStep === accountOpeningSteps.updateDetail &&
              accountStatus === "new" &&
              accountType?.toLowerCase() === accountTypes?.current ? (
                <UpdateDetailCurrentDialog />
              ) : (
                ""
              )}
              {accountOpeningStep === accountOpeningSteps.updateDetail &&
              accountStatus === "new" &&
              accountType?.toLowerCase() === accountTypes?.jointCurrent ? (
                <UpdateDetailJointCurrentDialog />
              ) : (
                ""
              )}
              {accountOpeningStep === accountOpeningSteps.updateDetail &&
              accountStatus === "new" &&
              accountType?.toLowerCase() ===
                accountTypes?.domiciliaryCurrent ? (
                <UpdateDetailDomiciliaryCurrentDialog />
              ) : (
                ""
              )}

              {accountOpeningStep === accountOpeningSteps.documentUpload &&
              accountStatus === "new" &&
              accountType?.toLowerCase() === accountTypes?.swiftSavings ? (
                <UploadDocumentSwiftSavingsDialog />
              ) : (
                ""
              )}
              {accountOpeningStep === accountOpeningSteps.documentUpload &&
              accountStatus === "new" &&
              accountType?.toLowerCase() === accountTypes?.regularSavings ? (
                <UploadDocumentSavingsDialog />
              ) : (
                ""
              )}
              {accountOpeningStep === accountOpeningSteps.documentUpload &&
              accountStatus === "new" &&
              accountType?.toLowerCase() === accountTypes?.minorSavings ? (
                <UploadDocumentMinorSavingsDialog />
              ) : (
                ""
              )}
              {accountOpeningStep === accountOpeningSteps.documentUpload &&
              accountStatus === "new" &&
              accountType?.toLowerCase() === accountTypes?.jointSavings ? (
                <UploadDocumentJointSavingsDialog />
              ) : (
                ""
              )}

              {accountOpeningStep === accountOpeningSteps.documentUpload &&
              accountStatus === "new" &&
              accountType?.toLowerCase() ===
                accountTypes?.domiciliarySavings ? (
                <UploadDocumentDomiciliarySavingsDialog />
              ) : (
                ""
              )}
              {accountOpeningStep === accountOpeningSteps.documentUpload &&
              accountStatus === "new" &&
              accountType?.toLowerCase() === accountTypes?.current ? (
                <UploadDocumentCurrentDialog />
              ) : (
                ""
              )}
              {accountOpeningStep === accountOpeningSteps.documentUpload &&
              accountStatus === "new" &&
              accountType?.toLowerCase() === accountTypes?.jointCurrent ? (
                <UploadDocumentJointCurrentDialog />
              ) : (
                ""
              )}
              {accountOpeningStep === accountOpeningSteps.documentUpload &&
              accountStatus === "new" &&
              accountType?.toLowerCase() ===
                accountTypes?.domiciliaryCurrent ? (
                <UploadDocumentDomiciliaryCurrentDialog />
              ) : (
                ""
              )}

              {accountOpeningStep ===
              accountOpeningSteps.accountOpeningSuccess ? (
                accountStatus === "new" ? (
                  <SuccessDialog />
                ) : (
                  <AccountOpeningSuccessDialog />
                )
              ) : (
                ""
              )}

              {accountOpeningStep === accountOpeningSteps.addReference && (
                <>
                  {accountStatus === "new" ? (
                    accountType?.toLowerCase() ===
                    accountTypes?.domiciliaryCurrent ? (
                      <AddRefDomcurrent />
                    ) : (
                      <AddRefefAcurrent />
                    )
                  ) : (
                    <AddReferenceCurrentDialog />
                  )}
                </>
              )}

              {/*  */}

              {accountOpeningStep === "ex-bvn-validation" &&
              accountStatus === "existing" ? (
                <ExBvnValidationDialog />
              ) : (
                ""
              )}

              {accountOpeningStep === accountOpeningSteps.updateDetail &&
              accountStatus === "existing" ? (
                <ExUpdateDetailsSavingsDialog />
              ) : (
                ""
              )}

              {accountOpeningStep === accountOpeningSteps.documentUpload &&
              accountStatus === "existing" &&
              accountType?.toLowerCase() === accountTypes?.regularSavings ? (
                <ExUploadDocumentSavingsDialog />
              ) : (
                ""
              )}

              {accountOpeningStep === accountOpeningSteps.documentUpload &&
              accountStatus === "existing" &&
              accountType?.toLowerCase() === accountTypes?.swiftSavings ? (
                <ExUploadDocumentsSwiftSavingsDialog />
              ) : (
                ""
              )}
              {accountOpeningStep === accountOpeningSteps.documentUpload &&
              accountStatus === "existing" &&
              accountType?.toLowerCase() === accountTypes?.minorSavings ? (
                <ExUploadDocumentsMinorSavings />
              ) : (
                ""
              )}
              {accountOpeningStep === accountOpeningSteps.documentUpload &&
              accountStatus === "existing" &&
              accountType?.toLowerCase() === accountTypes?.jointSavings ? (
                <ExUploadDocumentsJointSavingsDialog />
              ) : (
                ""
              )}
              {accountOpeningStep === accountOpeningSteps.documentUpload &&
              accountStatus === "existing" &&
              accountType?.toLowerCase() ===
                accountTypes?.domiciliarySavings ? (
                <ExUploadDocumentsDomiciliarySavingsDialog />
              ) : (
                ""
              )}
              {accountOpeningStep === accountOpeningSteps.documentUpload &&
              accountStatus === "existing" &&
              accountType?.toLowerCase() === accountTypes?.current ? (
                <ExUploadDocumentsCurrentDialog />
              ) : (
                ""
              )}
              {accountOpeningStep === accountOpeningSteps.documentUpload &&
              accountStatus === "existing" &&
              accountType?.toLowerCase() === accountTypes?.jointCurrent ? (
                <ExUploadDocumentJointCurrentDialog />
              ) : (
                ""
              )}
              {accountOpeningStep === accountOpeningSteps.documentUpload &&
              accountStatus === "existing" &&
              accountType?.toLowerCase() ===
                accountTypes?.domiciliaryCurrent ? (
                <ExUploadDocumentDomiciliaryCurrentDialog />
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OpenAccount;
